import {TableFooterData} from "../../../../models/table-footer/table.footer.data";
import {Return} from "../../../../models/documents/returns/returns";

export const generateDocumentDetails = (invoice: Return): TableFooterData => {
    return {
        qty: invoice.qty,
        taxPercent: invoice.vatPercent,
        totalWeight: 0,
        taxAmount: invoice.subtotalVat,
        totalAmount: invoice.subtotal,
        grandTotalAmount: invoice.grandTotal
    }
}